export { default } from "./statusPaid";
